<template>
    <div class="mainsearch home-search">
        <form @submit.prevent="submitHandler">
            <div class="form">
                <div class="row">
                    <div class="col-12">
                        <div class="mainsearch__heading">Інформація по житлу</div>
                    </div>
                </div>
                <div class="row row-cols-lg-5">
                    <div class="col col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Об'єкт страхування</label>
                            <multiselect
                                :class="{'form-control' : true, 'is-invalid' : (!$v.homeType.required) && submitCheck}"
                                v-model="homeType"
                                :options="homeTypes"
                                placeholder="Наприклад, квартира"
                                :max-height="120"
                                :allow-empty="false"
                                label="name"
                            >
                            </multiselect>
                            <small class="error" v-if="!$v.homeType.required && submitCheck">Виберіть об'єкт страхування</small>
                        </div>
                    </div>
                    <div class="col col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Страхова сума</label>
                            <multiselect
                                :class="{'form-control' : true, 'is-invalid' : (!$v.insuranceAmount.required) && submitCheck}"
                                :options="insuranceAmounts"
                                v-model="insuranceAmount"
                                placeholder="Наприклад, 500 000"
                                :max-height="120"
                                :allow-empty="false"
                                label="name"
                            >
                            </multiselect>
                            <small class="error" v-if="!$v.insuranceAmount.required && submitCheck">Виберіть страхову суму</small>
                        </div>
                    </div>
                    <div class="col col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Період страхування</label>
                            <multiselect
                                :class="{'form-control' : true, 'is-invalid' : (!$v.insurancePeriod.required) && submitCheck}"
                                :options="insurancePeriods"
                                v-model="insurancePeriod"
                                placeholder="Наприклад, 5 місяців"
                                :max-height="120"
                                :allow-empty="false"
                                label="name"
                            >
                            </multiselect>
                            <small class="error" v-if="!$v.insurancePeriod.required && submitCheck">Виберіть період страхування</small>
                        </div>
                    </div>
                    <div class="col col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Початок дії</label>
                            <date-picker v-model="startDate" :config="optionsStartDate" :class="['form-control', 'date-input', {invalid: !$v.startDate.required && submitCheck}]" placeholder="Початок дії"></date-picker>
                            <small class="error" v-if="!$v.startDate.required && submitCheck">Вкажіть початок дії</small>
                            <div class="form-group__descr">Франшиза 10 днів</div>
                        </div>
                    </div>
                    <div class="col col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Заробіток</label>
                            <multiselect
                                :class="{'form-control' : true, 'is-invalid' : (!$v.earning.required) && submitCheck}"
                                :options="earnings"
                                v-model="earning"
                                placeholder="Наприклад, 15%"
                                :max-height="120"
                                :allow-empty="false"
                                label="name"
                                v-loading="loadEarnings"
                            >
                            </multiselect>
                            <small class="error" v-if="!$v.earning.required && submitCheck">Виберіть відсоток заробітку</small>
                        </div>
                    </div>
                    <div class="col-lg-12 insurance-nav d-flex justify-content-center">
                        <button class="btn-blue-w" type="submit">
                            Показати результати
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <InsuranceHomeBanner v-show="showBanner" />
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { required } from 'vuelidate/lib/validators';
import { tariffsList } from '@/api/homeInsuranceCompany';
import InsuranceHomeBanner from '@/views/home/components/InsuranceHomeBanner.vue';

export default {
  components: { Multiselect, InsuranceHomeBanner },

  props: [
    'dataHomeType',
    'dataInsuranceAmount',
    'dataInsurancePeriod',
    'dataStartDate',
    'dataEarning',
    'dataShowBanner',
  ],

  data() {
    return {
      homeTypes: [
        { id: 1, name: 'Квартира', param: 'flat' },
        { id: 2, name: 'Будинок', param: 'house' },
      ],
      insuranceAmounts: [
        { id: 1, name: '500 000', param: 500000 },
        { id: 2, name: '700 000', param: 700000 },
        { id: 3, name: '1 000 000', param: 1000000 },
        { id: 4, name: '2 000 000', param: 2000000 },
        { id: 5, name: '2 500 000', param: 2500000 },
        { id: 6, name: '3 000 000', param: 3000000 },
        { id: 7, name: '4 000 000', param: 4000000 },
        { id: 8, name: '5 000 000', param: 5000000 },
      ],
      insurancePeriods: [
        { id: 1, name: '5 місяців', param: '5m' },
        { id: 2, name: '6 місяців', param: '6m' },
        { id: 3, name: '7 місяців', param: '7m' },
        { id: 4, name: '8 місяців', param: '8m' },
        { id: 5, name: '9 місяців', param: '9m' },
        { id: 6, name: '10 місяців', param: '10m' },
        { id: 7, name: '11 місяців', param: '11m' },
        { id: 8, name: '12 місяців', param: '12m' },
      ],
      loadEarnings: true,
      earnings: [],
      optionsStartDate: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 10),
        maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 100),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
          time: 'fa fa-clock-o',
          date: 'fa fa-calendar',
        },
      },
      homeType: null,
      insuranceAmount: null,
      insurancePeriod: null,
      startDate: moment(new Date(new Date().getFullYear(), new Date().getMonth(), (new Date().getDate() + 1))).format('DD.MM.YYYY'),
      earning: null,
      submitCheck: false,
      showBanner: true,
    };
  },

  validations: {
    homeType: { required },
    insuranceAmount: { required },
    insurancePeriod: { required },
    startDate: { required },
    earning: { required },
  },

  created() {
    this.fetchTariffs();
    this.fetchParams();
  },

  methods: {
    submitHandler() {
      this.submitCheck = true;

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      const params = {
        homeType: this.homeType,
        insuranceAmount: this.insuranceAmount,
        insurancePeriod: this.insurancePeriod,
        startDate: (typeof this.startDate.getMonth === 'function') ? this.startDate.toLocaleDateString() : this.startDate,
        earning: this.earning,
      };

      this.$store.commit('SET_HOME_SEARCH_PARAMS', params);

      if (this.checkResultRoute()) {
        this.$router.go();
      } else {
        this.$router.push({ name: 'homeResults' });
      }
    },

    checkResultRoute() {
      return this.$router.currentRoute.name === 'homeResults';
    },

    fetchTariffs() {
      this.loadEarnings = true;
      tariffsList()
        .then((response) => {
          this.earnings = response.data.data.sort((a, b) => a.value - b.value);
          this.loadEarnings = false;
        })
        .catch((err) => {
          this.loadEarnings = false;
        });
    },

    fetchParams() {
      this.homeType = this?.dataHomeType ?? this.homeType;
      this.insuranceAmount = this?.dataInsuranceAmount ?? this.insuranceAmount;
      this.insurancePeriod = this?.dataInsurancePeriod ?? this.insurancePeriod;
      this.startDate = this?.dataStartDate ?? this.startDate;
      this.earning = this?.dataEarning ?? this.earning;
      this.showBanner = this?.dataShowBanner ?? this.showBanner;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
